import { convertEmptyStringToUndefined } from 'services/utils'
import {
  APIPricingRuleSet,
  PricingTimePeriodRule,
  PricingMinHoursRule,
} from '../types'
import { LocationPricingRuleSet } from './types/internal/location-models'

// ============
// PARSE
// ============

export const byRulesPricingParse = ({
  timePeriodRules,
  minHoursRules,
  ...rest
}: APIPricingRuleSet): LocationPricingRuleSet => ({
  ...rest,
  pricingRules: [
    ...timePeriodRules.map((r) => ({
      ...r,
      mode: 'tpr',
    })),
    ...minHoursRules
      .map((r) => ({
        ...r,
        mode: 'nhr',
      }))
      .sort((a, b) => (a.atLeast > b.atLeast ? 1 : -1)),
  ] as (PricingTimePeriodRule | PricingMinHoursRule)[],
})

// ============
// WRITE
// ============

export const byRulesPricingWrite = ({
  pricingRules,
  ...rest
}: LocationPricingRuleSet): APIPricingRuleSet => {
  const mappedRules = pricingRules.map(({ name, ...rest }) => ({
    ...rest,
    name: convertEmptyStringToUndefined(name),
  }))
  return {
    ...rest,
    timePeriodRules: mappedRules.filter(
      (r) => r.mode === 'tpr'
    ) as PricingTimePeriodRule[],
    minHoursRules: mappedRules.filter(
      (r) => r.mode === 'nhr'
    ) as PricingMinHoursRule[],
  }
}
